import useGetAllShopEmailTemplatesSuspense from "@babackapp/private-api-client/client/use-get-all-shop-email-templates";
import { Button } from "@babackapp/ui/components/button";
import { useTranslation } from "react-i18next";
import { Position } from "@xyflow/react";
import { ExternalLink } from "lucide-react";
import useCurrentShopSuspense from "../../hooks/use-current-shop-suspense";
import { BaseHandle } from "../../components/base-handle";
import {
  BaseNode,
  BaseNodeContent,
  BaseNodeFooter,
} from "../../components/base-node";
import { WebActionNodeProps } from "./types";
import { useNodeData } from "../../hooks/use-node-data";
import { ActionNodeDataDto } from "@babackapp/private-api-client/types";

export const WEB_TEMPLATE_NODE_WIDTH = 280;
export const WEB_TEMPLATE_NODE_HEIGHT_ESTIMATION = 160;

export function TrackingPageActionNodeEditor({ id, data }: WebActionNodeProps) {
  const { t } = useTranslation("trackoffice");
  const { data: shop } = useCurrentShopSuspense();
  const { data: allTemplates } = useGetAllShopEmailTemplatesSuspense(shop.id);

  const liveData = useNodeData<ActionNodeDataDto>(id);
  const templateId =
    liveData?.actionType === "update_web"
      ? (liveData.config as any).templateId
      : data.templateId;
  const isDefaultTemplate = !templateId || templateId === "null";

  const handleCustomizeClick = () => {
    if (!isDefaultTemplate) {
      window.open(
        `/shops/${shop.id}/notifications-templates/${templateId}`,
        "_blank",
      );
    }
  };

  // Filter templates to only show 'web' type
  const templates = allTemplates?.filter((template) => template.type === "web");

  const selectedTemplate = templates?.find(
    (template) => template.id === templateId,
  );

  return (
    <BaseNode nodeId={id} style={{ position: "relative" }}>
      <BaseNodeContent>
        <div className="flex flex-col gap-2 w-full">
          <div className="flex flex-col">
            <span className="text-xs  text-muted-foreground">Template</span>
            <span className="text-xs mt-1 font-semibold">
              {selectedTemplate?.title ?? "Default"}
            </span>
          </div>
        </div>
        <BaseHandle type="target" position={Position.Left} />
        <BaseHandle
          type="source"
          position={Position.Right}
          style={{ top: "50%", transform: "translateY(-50%)" }}
        />
      </BaseNodeContent>

      {!isDefaultTemplate && (
        <BaseNodeFooter>
          <div className="justify-end items-end w-full flex">
            <Button
              size="icon-xs"
              variant="ghost"
              className="nodrag shrink-0"
              onClick={handleCustomizeClick}
              title={t(
                "workflowsEditor.webNode.customizeTemplate",
                "Customize template",
              )}
            >
              <ExternalLink className="size-3" />
            </Button>
          </div>
        </BaseNodeFooter>
      )}
    </BaseNode>
  );
}
